export default __webpack_public_path__ + "static/media/House.d31f4acb.svg";